// Bottone "Assistenza" globalmente accessibile dalla topbar. Apre il modal
// SupportNewTicketDialog. Sostituisce il vecchio ThemeToggle nell'header.
//
// Visibile a tutti gli utenti loggati; se chi clicca non e' founder
// (RLS rifiuta l'INSERT), il modal mostra l'errore "Solo i founder…".
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { LifeBuoy } from "lucide-react";
import { Button } from "@v2/components/ui/button";
import { SupportNewTicketDialog } from "./SupportNewTicketDialog";

export function SupportTriggerButton({
  activeTeamId,
  variant = "icon",
}: {
  activeTeamId: string | null;
  /** "icon" = icona + label (label nascosta sotto sm, per topbar). "full" = icona + label sempre visibile (per mobile sheet). */
  variant?: "icon" | "full";
}) {
  const { t } = useTranslation("support");
  const [open, setOpen] = useState(false);

  return (
    <>
      {variant === "icon" ? (
        <Button
          variant="ghost"
          size="sm"
          onClick={() => setOpen(true)}
          aria-label={t("trigger.label")}
          title={t("trigger.tooltip")}
          className="gap-2"
        >
          <LifeBuoy className="h-5 w-5" />
          <span>{t("trigger.label")}</span>
        </Button>
      ) : (
        <Button
          variant="outline"
          className="w-full"
          onClick={() => setOpen(true)}
        >
          <LifeBuoy className="h-4 w-4" />
          {t("trigger.label")}
        </Button>
      )}
      <SupportNewTicketDialog
        open={open}
        onOpenChange={setOpen}
        activeTeamId={activeTeamId}
      />
    </>
  );
}
